import axios from 'axios'
import { MongoTask } from './types'

import { API_URL as API_BASE_URL } from '../config'

export const api = {
  getTasks: async (): Promise<MongoTask[]> => {
    const response = await axios.get(`${API_BASE_URL}/todos`)
    return response.data
  },

  createTask: async (task: { title: string; description: string; status: string }): Promise<MongoTask> => {
    const response = await axios.post(`${API_BASE_URL}/todos`, task)
    return response.data
  },

  updateTask: async (task: { _id: string; title: string; description: string; status: string }): Promise<MongoTask> => {
    const response = await axios.put(`${API_BASE_URL}/todos/${task._id}`, task)
    return response.data
  },

  deleteTask: async (taskId: string) => {
    await axios.delete(`${API_BASE_URL}/todos/${taskId}`)
  }
}
